import { render } from "./MySQL.vue?vue&type=template&id=511fd8d2&scoped=true"
import script from "./MySQL.vue?vue&type=script&lang=js"
export * from "./MySQL.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-511fd8d2"

export default script